import { render } from "./FileView.vue?vue&type=template&id=ac487daa"
import script from "./FileView.vue?vue&type=script&lang=js"
export * from "./FileView.vue?vue&type=script&lang=js"

import "./FileView.vue?vue&type=style&index=0&id=ac487daa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/FileView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac487daa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac487daa', __exports__)) {
    api.reload('ac487daa', __exports__)
  }
  
  module.hot.accept("./FileView.vue?vue&type=template&id=ac487daa", () => {
    api.rerender('ac487daa', render)
  })

}


export default __exports__